import { useEffect } from "react";

import dayjs from "dayjs";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import { getEventStartTime, getEventEndTime } from "../../services/EventService";


const EventDetails = ({ school, eventDetails }) => {
  useEffect(() => {}, []);


  const getEventTime = (school, eventDate) => {
    if (eventDate == null) {
      return ``;
    }
    return `${getEventStartTime(eventDate)} - ${getEventEndTime(eventDate)}`;
  }


  return (
    <Table style={{ marginTop: "1em", marginBottom: "1em" }}>
      <Thead>
        <Tr>
          <Th>Event Name</Th>
          <Th>Date</Th>
          <Th>Time</Th>
          <Th>Owner</Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>{eventDetails.title}</Td>
          <Td>
            {dayjs(eventDetails.startDate).format("MM/DD")}
          </Td>
          <Td>{getEventTime(school, eventDetails)}</Td>
          <Td>{eventDetails.last_name}</Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

export default EventDetails;
